/**
 * `/ai/claude` — Anthropic Claude usage.
 *
 * Its own page for the same reason as the Copilot one: a different vendor and a
 * different upstream from the Azure estate the overview measures.
 *
 * Expect this to read as unconfigured for now, and that is the honest state
 * rather than a gap: the claude.ai Team plan ships no metrics API at all, so the
 * section explains what unlocks it (a Claude Console organisation's Admin key)
 * instead of rendering zeros that would look like measured silence.
 */

import { ClaudeSection } from "./claude-section";
import { AiPageFrame } from "./page-frame";
import { AI_CLAUDE_PATH } from "./params";

export function AiClaudePage() {
  return (
    <AiPageFrame path={AI_CLAUDE_PATH} ownsItsQuery>
      <ClaudeSection />
    </AiPageFrame>
  );
}
